import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Wrapper, CouponDetails, Condition, LineAvatar, FlexContainer, ColumnContainer } from './styled'

interface CouponItemSkeletonProps {
  lineAvatar?: boolean
}

const CouponItemSkeleton = ({ lineAvatar }: CouponItemSkeletonProps) => {
  return (
    <Wrapper>
      <Skeleton containerClassName="container" width={64} height={36} />
      <CouponDetails style={{ lineHeight: 1 }}>
        <Skeleton containerClassName="container" width={150} height={14} />
        <FlexContainer>
          <ColumnContainer>
            <Skeleton containerClassName="container" width={80} height={10} />
            {lineAvatar && (
              <LineAvatar>
                <Skeleton containerClassName="container" width={18} height={18} circle />
                <Skeleton containerClassName="container" width={50} height={10} />
              </LineAvatar>
            )}
          </ColumnContainer>
          <Condition>
            <Skeleton containerClassName="container" width={50} height={12} />
          </Condition>
        </FlexContainer>
      </CouponDetails>
    </Wrapper>
  )
}

export default CouponItemSkeleton
